import { useRef, useState } from "react"
import { Box, styled, Pagination, Grid } from "@mui/material"
import ProductCard from "./ProductCard"

const DetallesTab = ({
  productos,
  inputName,
  inputImage,
  inputPrecio,
  inputCodigo,
  productosSeleccionados,
  setProductosSeleccionados,
}) => {
  //  items per page
  const itemsPerPage = 6
  const [page, setPage] = useState(1)
  const startIndex = (page - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const productosPaginados = productos.slice(startIndex, endIndex)
  const handlePageChange = (event, value) => {
    setPage(value)
  }
  // Referencia para Articulos
  const handleAgregarProducto = (producto) => {
    setProductosSeleccionados((prevProducts) => {
      const existingProduct = prevProducts.find((p) => p?.[inputCodigo] === producto?.[inputCodigo])
      if (existingProduct) {
        // Incrementa la cantidad si el producto ya está en el detalle
        return prevProducts.map((p) =>
          p?.[inputCodigo] === producto?.[inputCodigo] ? { ...p, cantidad: p.cantidad + 1 } : p,
        )
      } else {
        // Agrega el producto al detalle con una cantidad inicial de 1
        return [...prevProducts, { ...producto, cantidad: 1 }]
      }
    })
  }

  return (
    <>
      <Grid item xs={8}>
        <Box></Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, // Cambia a una columna en pantallas pequeñas
            gap: 3,
            height: "100%",
            overflowY: "auto",
          }}
        >
          {productosPaginados.map((producto, index) => (
            <ProductCard
              key={index}
              handleAgregar={handleAgregarProducto}
              producto={producto}
              inputCodigo={inputCodigo}
              inputName={inputName}
              inputImage={inputImage}
              inputPrecio={inputPrecio}
              // Pasa la referencia al ProductCard
            />
          ))}
        </Box>
      </Grid>
      <Box display="flex" justifyContent="center" mt={4}>
        <Pagination
          count={Math.ceil(productos.length / itemsPerPage)} // Calcula el número total de páginas
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </>
  )
}

export default DetallesTab
